import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Checkbox } from '@mui/material';
import { RadioButtonUnchecked } from '@mui/icons-material';
import styles from './WhatNext.module.css';

export default function WhatNext() {
  const { t } = useTranslation();
  const [step, setStep] = useState(1);

  const getImage = () => {
    switch (step) {
      case 1:
        return 'Group 914.png';
      case 2:
        return 'Group 900.png';
      case 3:
        return 'Group 928.png';
      default:
        return 'Group 914.png';
    }
  };

  const handleStep = (nextStep: number) => {
    setStep(nextStep);
  };

  return (
    <div className={styles.flexBox}>
      <div>
        <p className={`${styles.header} ${styles.blue}`}>{t('whatNext.title')}</p>
        <p className={`${styles.header}`}>{t('whatNext.titleSecond')}</p>
        <img className={styles.image} src={`${process.env.PUBLIC_URL}/images/${getImage()}`} alt="details" />
      </div>
      <div>
        <p className={styles.titleSection}>{t(`whatNext.section${step}`)}</p>
        <p className={styles.descriptionSection}>{t(`whatNext.section${step}Description`)}</p>
      </div>
      <div className={styles.buttonSlider}>
        <Checkbox
          className={`${styles.checkboxSlider} ${step === 1 ? styles.checked : ''}`}
          icon={<RadioButtonUnchecked />}
          checkedIcon={<span />}
          checked={step === 1}
          onChange={() => handleStep(1)}
        />
        <Checkbox
          className={`${styles.checkboxSlider} ${step === 2 ? styles.checked : ''}`}
          icon={<RadioButtonUnchecked />}
          checkedIcon={<span />}
          name="documents"
          checked={step === 2}
          onChange={() => handleStep(2)}
        />
        <Checkbox
          className={`${styles.checkboxSlider} ${step === 3 ? styles.checked : ''}`}
          icon={<RadioButtonUnchecked />}
          checkedIcon={<span />}
          name="bank-check"
          checked={step === 3}
          onChange={() => handleStep(3)}
        />
      </div>
    </div>
  );
}
